module.exports = __webpack_public_path__ + "img/index-bg.b1365e72.jpg";